import { State } from '@/types'
import { Store } from 'vuex'
import { createVerifyResult, applyValidationResults, validateField } from './utils'
import { VerifyResult } from '@/types'
import { validate } from 'vee-validate'
import limits from '../../constants/limits'

export default async function validateUploadFilesView(store: Store<State>) {
  const verifyResult = createVerifyResult('Files')
  const validationResults = await Promise.all([
    validateField(store.state.activeSubmission.files, 'no-failed-uploads'),
    validateField(store.state.activeSubmission.files, 'manuscript-file-required'),
    validateField(store.state.activeSubmission.files, 'cover-letter-required'),
    validateField(
      {
        dasCustomSelected: store.state.das.dasCustomSelected,
        dasCustomContent: store.state.das.dasCustomContent,
      },
      'data-availability-statement-option-required',
    ),
    validateField(store.state.activeSubmission.themedCollectionTitle, `max-characters-length:${limits.themedCollection.characters.title},Themed collection title must not exceed`),
    validateField(store.state.activeSubmission.peerReviewAnonymisation, 'anonymised-peer-review-option-required'),
    validateField(store.state.activeSubmission.themedCollectionResponse, 'themed-collection-option-required'),
  ])

  applyValidationResults(validationResults, verifyResult)

  verifyResult.valid = verifyResult.errors.length === 0

  store.commit('setVerifyResult', {
    key: 'uploadFilesVerifyResult',
    verifyResult,
  })
}

const baseVerifyResult: VerifyResult & { errorType: string } = {
  valid: false,
  errors: [],
  failedRules: {},
  field: 'Files',
  rules: '',
  errorType: 'Error',
}

export async function validateFiles(inputFiles: File[], fileType: string) {
  let verifyFiles = { ...baseVerifyResult }
  const inputdata = [inputFiles, fileType]

  await validate(inputdata, 'file-size|file-type').then((result) => {
    const errorMapping: Record<string, string> = {
      'total-file-size': 'Total file size limit exceeded',
      'individual-file-size': 'Maximum file size exceeded',
      'invalid-format': 'Invalid file',
    }
    const matchedError = Object.keys(errorMapping).find(key =>
      result.errors.some(error => error.includes(key)),
    )
    const errorType = matchedError ? errorMapping[matchedError] : 'Error'
    verifyFiles = {
      ...verifyFiles,
      valid: result.errors.length === 0,
      errors: result.errors.length !== 0 ? [result.errors.toString()] : [],
      failedRules: result.errors.length !== 0 ? { failedRuleError: result.errors.toString() } : {},
      errorType,
    }
  })
  return verifyFiles
}

export async function validateDuplicateFiles(files: File[]) {
  let verifyDuplicateFiles = { ...baseVerifyResult, errorType: 'Duplicate file' }
  await validate(files, 'file-duplicates').then((result) => {
    verifyDuplicateFiles = {
      ...verifyDuplicateFiles,
      valid: result.errors.length === 0,
      errors: result.errors.length !== 0 ? [result.errors.toString()] : [],
      failedRules: result.errors.length !== 0 ? { 'file-duplicates': result.errors.toString() } : {},
    }
  })
  return verifyDuplicateFiles
}
